import { createFormDataRequest } from "@/helpers/FormHelpers";
import CompanyCourseInstructor, {
  CompanyCourseInstructorFormSend,
} from "@/interfaces/CompanyCourseInstructor";
import CompanyCourseInstructorInvoice, {
  CompanyCourseInstructorInvoiceForm,
} from "@/interfaces/CompanyCourseInstructorInvoice";
import { IFilters, IPaginateResponse } from "@/interfaces/Fetch";
import api from "@/services/api";

export const companyCourseInstructorInvoicesApi = api.injectEndpoints({
  endpoints: (build) => ({
    getCompanyCourseInstructorInvoices: build.query<
      IPaginateResponse<CompanyCourseInstructorInvoice>,
      [string, string, string, IFilters]
    >({
      query: ([id, courseId, instructorId, data]) => {
        const params = createFormDataRequest(data);
        return {
          url: `/companies/${id}/courses/${courseId}/instructors/${instructorId}/invoices`,
          params,
        };
      },
      providesTags: (result, _error, [companyId, courseId, instructorId]) =>
        result
          ? [
              ...result.data.map(({ id }) => ({
                type: "CompanyCourseInstructorInvoices" as const,
                companyId,
                courseId,
                instructorId,
                id,
              })),
              {
                type: "CompanyCourseInstructorInvoices",
                companyId,
                courseId,
                instructorId,
                id: "LIST",
              },
            ]
          : [],
    }),
    storeCompanyCourseInstructorInvoice: build.mutation<
      CompanyCourseInstructor,
      [string, string, string, CompanyCourseInstructorInvoiceForm]
    >({
      query: ([companyId, courseId, instructorId, body]) => ({
        url: `/companies/${companyId}/courses/${courseId}/instructors/${instructorId}/invoices`,
        method: "POST",
        body,
      }),
      invalidatesTags: (
        _result,
        _error,
        [companyId, courseId, instructorId]
      ) => [
        {
          type: "CompanyCourseInstructorInvoices",
          companyId,
          courseId,
          instructorId,
          id: "LIST",
        },
      ],
    }),
    deleteCompanyCourseInstructorInvoice: build.mutation<
      CompanyCourseInstructor,
      [string, string, string, string]
    >({
      query: ([companyId, courseId, instructorId, invoiceId]) => ({
        url: `/companies/${companyId}/courses/${courseId}/instructors/${instructorId}/invoices/${invoiceId}`,
        method: "DELETE",
      }),
      invalidatesTags: (_result, _error, [companyId, courseId, invoiceId]) => [
        {
          type: "CompanyCourseInstructorInvoices",
          companyId,
          courseId,
          invoiceId,
          id: "LIST",
        },
      ],
    }),
  }),
  overrideExisting: true,
});

export const {
  useGetCompanyCourseInstructorInvoicesQuery,
  useDeleteCompanyCourseInstructorInvoiceMutation,
  useStoreCompanyCourseInstructorInvoiceMutation,
} = companyCourseInstructorInvoicesApi;
